
<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition" >
      <template v-slot:activator="{on}">
        <v-btn v-on="on" small color="white" >contas bancárias</v-btn>
      </template>
      <v-card v-if="dialog" style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">{{title}}</div>
        </v-card-title>
        <v-card-text>
          <v-alert v-if="loading" type="info" :value="true">
            Carregando...
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </v-alert>
          <v-alert v-if="!loading && !are_bank_accounts && !is_receipt_config " type="info" :value="true">
            Não possui conta bancária
          </v-alert>
          <template v-if="!loading && accounts.length && are_bank_accounts">
            <div v-for="account in accounts" :key="account.id" style="border: solid 1px #ccc; border-radius: 8px; padding:15px">
              <div> <b> Banco: </b> {{account.bank_name}}</div>
              <div> <b> Agência: </b> {{account.agency}}{{account.digit? ('-'+account.digit) : ''}} </div>
              <div> <b> Conta: </b> {{account.number}}{{account.account_digit? ('-'+account.account_digit) : ''}} </div>
              <div> <b> Tipo: </b> {{account.current_account? "Corrente" : "Poupança"}} </div>
              <div> <b> Titular: </b> {{account.name}}</div>
              <div> <b> Documento titular: </b> 
                {{accountTitularDoc(account)}} 
              </div>
            </div>
          </template>
          <template v-if="!loading && is_receipt_config">
            <receipt-config-form :model="accounts" ref='receipt_config' :is_readonly="true"></receipt-config-form>
          </template>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';
import ReceiptConfigForm from '@/_backoffice/_registrations/components/shared/forms/ReceiptConfigForm.vue'

export default {
  components: { ReceiptConfigForm },
  name: 'DialogDriverBankAccount',
  data() {
    return {
      dialog: false,
      loading: false,
      loadingText: null,
      accounts: [],

      are_bank_accounts: false,
      is_receipt_config: false
    }
  },
  computed:{
    title(){
      return "Contas Bancárias do Motorista"
    }
  },
  methods: {
    getFilter(){
      return {
        driver_id: this.$route.params.id
      }
    },
    getAccounts() {
      this.loading = true
      let filter = this.getFilter()
      Api.BankAccount.index( filter ).then(r=> r.data).then(r=> {
        if (r.data){
          this.are_bank_accounts = true
          r = r.data? r.data.map(d=>d.attributes) : r
          this.accounts = [...r]
        } else {
          this.is_receipt_config = true
          this.accounts = {...this.oneDriver}
        }
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    accountTitularDoc(account) {
      let doc = ''
      if (account.CPF && account.CPF.length >= '9'){
        doc = account.CPF
      } else if (account.CNPJ && account.CNPJ.length >= '11'){
        doc = account.CNPJ
      }
      return doc
    },
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        this.getAccounts()
      } else if (nv == false){
        this.accounts = []
      }
    }
  },
}
</script>